module.exports = {
  UserDefinedField1: 'ユーザー定義項目d1',
  UserDefinedField2: 'ユーザー定義項目d2',
  UserDefinedField3: 'ユーザー定義項目d3',
  UserDefinedField4: 'ユーザー定義項目d4',
  query: 'Query',
  viewDetails: 'View Details',
  collectInvoice: 'Collect invoice',
  print: 'Print',
  newPaymentRequest: 'New Payment Request',
  deletePaymentRequest: 'Delete Payment Request',
  submintPaymentRequest: 'SUBMIT Payment Request',
  submit: 'Submit',
  delete: 'Delete',
  businessApproval: 'Business approval',
  officeApproval: 'Office approval',
  departmentApproval: 'Department approval',
  financialApproval: 'Financial approval',
  return: 'Return',
  financialAudit: 'Financial Audit',
  applicationStatus: 'Application status',
  notSubmitted: 'Not submitted',
  awaitBusinessApproval: 'Await Business approval',
  awaitFinancialApproval: 'Await Financial approval',
  NosubmitWeaver: 'Nosubmit Weaver',
  WeaverApproving: 'Weaver Approving',
  WeaverApproved: 'Weaver Approved',
  approval: 'Approval',
  unpaid: 'Unpaid',
  all: 'All',
  inquiryWay: 'Inquiry way',
  accordingToCharge: 'According to charge',
  accordingToBusiness: 'According to business',
  includeReceivables: 'Include receivables',
  removeCharge: 'Remove charge',
  addCharge: 'Add charge',
  back: 'Back',
  next: 'Next',
  save: 'Save',
  cancel: 'Cancel',
  saveAndAdd: 'Save and Add',
  chargeRemark: 'Charge Remark',
  containerNo: 'コンテナ番号',
  destinationAgent: '仕向駅代理',
  receivablesWriteOfStatus: 'Receivables Write Of Status',
  businessNumber: '取引番号',
  consignationCompany: '委託会社',
  settlementAgent: '決算代理',
  mbl: 'MBL（親B/L）',
  importhbl: 'IMPORT HBL',
  vessel: '船名',
  voyage: '航次',
  billNo: '請求番号',
  inputBy: '入力者',
  accountStatementNo: 'Account statement No',
  invoiceNo: 'インボイス番号',
  itemNo: 'プロジェクト番号',
  businessType: '業務種別',
  solicitationType: '業務種別',
  amountRange: '金額帯',
  chargeItem: '請求項目コード',
  businessDate: '業務日付',
  etd: 'ETD（出発予定日）',
  eta: 'ETA（到着予定日）',
  atd: 'ATD（実出発日）',
  ata: 'ATA（実到着日）',
  currency: '通貨',
  operation: '操作内容',
  sales: '売上',
  advanceMoneyOrNot: '前受金かどうか',
  adjustedOrNot: '調整済みかどうか',
  wroteOffOrNot: 'Wrote off or not',
  generatedBillsOrNot: '請求書作成済みかどうか',
  invoicedOrNot: 'インボイス発行済みかどうか',
  appliedForPaymentOrNot: '支払申請済みかどうか',
  lclMasterOrNot: 'LCLマスターかどうか',
  masterFlagOrNot: 'マスターフラグかどうか',
  department: 'Department',
  contactPerson: '連絡先',
  settlementType: '決済種別',
  invoicingMethod: '請求方式',
  accrued: '未払計上',
  businessReferenceNumber: '業務参照番号',
  SONO: 'SONO',
  warehouseNo: '倉庫番号',
  bookingNo: ' ブッキング番号',
  auditor: '審査担当者',
  settlementCompany: '決済会社',
  businessStatus: '業務ステータス',
  feeStatus: '費用ステータス',
  confirmationStatus: '確認ステータス',
  settleAccountsTo: '決算勘定',
  customerChineseName: '委託先（中国語）',
  vesselAndVoyage: '船名/航次',
  portOfLoading: '積出港',
  portOfDestination: '仕向港',
  customerService: 'カスタマーサービス',
  financialDate: '会計処理日',
  domesticInternational: ' 国内／国外',
  paymentType: 'Payment type',
  unit: ' 単位',
  quantity: '数量',
  unitPrice: '単価',
  taxIncludedPrice: '税込金額',
  taxExcludedPrice: '税抜金額',
  taxRate: '税率',
  taxAmount: '消費税額',
  theAmountOfWriteOffs: '消込金額',
  currencyAmountOfWriteOffs: '消込済金額通貨種合計',
  amountNotWrittenOff: '未収残高',
  creator: '作成者',
  dateOfCreation: 'Date of Creation',
  customer: '顧客',
  carrier: 'Carrier',
  applicationNo: 'Application No',
  status: 'Status',
  bySettlementAgent: 'By settlement agent',
  oceanExport: 'Ocean export',
  oceanImport: 'Ocean import',
  airExport: 'Air export',
  airImport: 'Air import',
  exchangeRate: '為替レート',
  amount: 'Amount',
  paymentPeriod: 'Payment period',
  paymentPeriodUnit: 'Payment period unit',
  methodOfPayment: 'Method of payment',
  applicant: 'Applicant',
  dateOfApplication: 'Date of application',
  remarks: '備考',
  purpose: 'Purpose',
  postscript: 'Postscript',
  preRemarks: 'Notes on Advance Payment',
  ticketNo: '請求書番号',
  workflowNo: 'WorkflowNo',
  total: '合計',
  controlledOrNot: '制御対象フラグ',
  uncheck: 'Uncheck',
  newActualReceipt: 'New actual receipt',
  newActualPayment: 'New actual payment',
  edit: 'Edit',
  invalid: 'Invalid',
  viewWriteOffList: 'View write off list',
  receiptDate: 'Receipt date',
  paymentDate: 'Payment date',
  receipt: 'Receipt',
  payment: 'Payment',
  new: 'New',
  edit2: 'edit',
  containerSizeAmount: 'Container size/amount',
  writeOffCurrency: 'Write off currency',
  writeOffExchangeRate: 'Write off Exchange rate',
  chargeOriginalCurrency: 'Charge original currency',
  chargeOriginalAmount: 'Charge original amount',
  chargeOriginalExchangeRate: 'Charge original exchange rate',
  monetaryEquivalent: 'Monetary equivalent',
  originalAmount: 'original amount',
  receivables: 'Receivables',
  payables: 'Payables',
  totalWriteOffs: 'Total write offs',
  cancelPartialWriteOff: 'Cancel partial write off',
  exportExcel: 'Export excel',
  exportPDF: 'Export PDF',
  writeOffList: '消込明細',
  isReceivable: '売掛',
  customJobType: '通関業務区分',
  HBL: 'HBL',
  export: 'Export',
  import: 'Import',
  invoiceHeader: '請求書ヘッダー名',
  sellerInvoiceTitle: 'Seller invoice title',
  separateNumber: '分割番号',
  modifyTime: 'Update Payment Time',
  modifiedBy: 'Update Payment Person',
  relatedJob: '関連業務',
  trustFromJob: '引受元業務',
  carrierId: '運送業者コード',
  confirmDate: '確認日',
  confirmUser: '確認者',
  planner: '支払計画担当者',
  customerContact: '顧客担当者',
  isNeedInvoice: '請求書要否',
  confirmRemarks: '確定備考',
  needInvoice: '請求書要否',
  invoiceDate: '請求日',
  invoiceDateAll: '請求日',
  invoiceState: '請求ステータス',
  writeOffDate: '消込日',
  totalCurrency: 'Currency Amount',
  billPaymentNo: '支払申請書番号',
  bankOfDeposit: 'Bank Of Deposit',
  bankAccount: 'Bank Account',
  changePaymentRequest: 'Change Payment Request',
  couldNotSearhWriteOffJobFromThisWindow: 'Tip:Could Not Searh WriteOff Job Or Charge From This Window',
  writeOffSerialNumber: '消込番号',
  payReceiveDate: '入出金日',
  portOfDestinationAirport: '仕向空港',
  portOfDestinationSeaport: '仕向港（海上）',
  portOfDischargeSeaport: '揚げ地港（海上）',
  portOfLoadingAirport: '積載空港',
  portOfLoadingSeaport: '積出港（海上）',
  portOfTransfer: '経由港',
  businessCreateDate: '業務登録日',
  approveHistoryNode: 'Payment Approve Node',
  invoice_voucherDate: 'Voucher Date2',
  time: 'Time',
  approveTime: 'Approve Time',
  operator: 'Operator',
  approval_results: 'Approval Results',
  applicationDepartment: 'Application Department',
  settleDepartmentPrefix: '決済部門',
  writeOffStatus: 'Write off status',
  moneyWriteOffStatus: '費用消込状態',
  sendWeaver: 'Send Cloud Platform Audit',
  receivablesAndPayables: 'Receivables And Payables',
  operationDate: '処理日',
  newPaymentRequest_SR: 'Payment Request',
  deletePaymentRequest_SR: 'Delete',
  sendWeaver_SR: 'Send to Cloud platform',
  viewDetails_SR: 'View Details',
  lastInvoicingDate: 'Last Invoicing Date',
  paymentRequestState: 'Payment Request State',
  Cargo_ApplicantPassTips: 'Do you agree with this payment application？',
  Cargo_ApplicantReturnToSubmitterTips: 'This application will be returned to the submitter, are you sure to return it?',
  Cargo_ApplicantReturnToBusinessTips: 'This application will be returned to the business approver, are you sure to return it?',
  Cargo_ApplicantReturnToFinancialTips: 'This application will be returned to the financial approver, are you sure to return it?',
  Cargo_ApplicantReturnTips: 'This application will be returned to the submitter, are you sure to return it?',
  approveReason: 'Please enter the reason for consent',
  returnReason: 'Please enter the return reason',
  bdApproveState: 'Business approval status',
  ccApproveState: 'Financial approval status',
  finApproveState: 'Final approval status',
  receiptPaymentNo: 'Receipt and payment voucher number'
}
